import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { RegisterService } from '../../../auth/services/register.service';
import { ILookupCategory } from '../../../shared/models/lookup.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { DataService, SharedService } from '../../../shared/services';
import { DocTemplateLogo, LookupCategory, MSAType} from '../../../shared/enums/EnumsVMS';
import { VMSConstants } from '../../../shared/constants/vms-constants';
import { VendorOnboarding, VendorOnboardingEmailAdd } from '../../models/vendor-onboarding';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import{VendorOnboardingService} from '../../../admin/services/vendor-onboarding.service'
import { User} from '../../../auth/models';
import { DomSanitizer } from '@angular/platform-browser';
import { CompanyService } from '../../../users/services/company.service';
import { valHooks } from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { BackToSearchService } from '../../../shared/services/back-to-search.service';
import { JwtService } from '../../../auth/services/jwt.service';


@Component({
  selector: 'app-vendor-onboarding',
  templateUrl: './vendor-onboarding.component.html',
  styleUrls: ['./vendor-onboarding.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]

})
export class VendorOnboardingComponent implements OnInit {
  VendorOnboardingForm:FormGroup;
  public selectedMSATypeId: Array<any> = [];
  public selectedExhibitTypeId: Array<any> = [];
  msaTypes: ILookupCategory;
  arrMSAType;
  insuranceExhibit:ILookupCategory;
  arrInsuranceExhibit;
  paymentTerms;
  isSqlComments: boolean = false;
  vendorName: string;
  vendorNameAvail: any;
  taxIdAvail:any;
  taxIdNumber: string;
  taxIdNumberLength: number;
  isVendorAvailability: boolean = false;
  isSaveAvailable: boolean = false;
  clientListForRegistration;
  isValidateVendorCategory:boolean = false;
  vendorCategoryId;
  selectedClientValidOnRegistration: boolean = true;
  categoryName;
  invoiceTermEnable:boolean = false;
  invoiceTermsId: any;
  public selectedInvoiceTermsId: Array<any> = [];
  public selectedClientRegistrationId: Array<any> = [];
  invoiceTerms: ILookupCategory;
  arrInvoiceTerms;
  arrClientListForRegistration;
  contractEndDate_Start: Date = new Date();
  insuranceExhibitId:string;
  msaTypeId:number;
  loggedInUserProfile: User;
  isMSAType:boolean=false;
  isInsuranceExhibit:boolean=false;
  msaTemplate:any="";
  poTemplate:any="";
  ncaTemplate:any="";
  previewTemplate:boolean=false;
  isEmailDialog:boolean=false;
  //@ViewChild('previewDocumentTemplate') companyNotesDescriptionContainer: ElementRef;
  // logoOnMSA ='data:image/png;base64,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';
  logoOnLeft :string = DocTemplateLogo.DevCareLogo;
  logoOnRight: string = DocTemplateLogo.CMMIISOLogo;
  isNCA:boolean=false;
  isMSATemplateGenerated:boolean=false;
  isPOTemplateGenerated:boolean=false;
  isNCATemplateGenerated:boolean=false;
  public paymentTermsIds: Array<any> = [];
  previewSpecialMSATemplate:boolean=false;
  previewDocumentTemplate;
  specialMSATemplateForUpdate:any="";
  isPaymentTermRequired: boolean = false;
  selectedPaymentTermsIds;
  selectedPaymentTermsEditIds;
  vendorOnboardingEditId:boolean=false;
  selectedPaymentTerms = 'You may select multiple payment terms';
  showPaymentTerms = false;
  vendorOnboardingEmailAdd:  VendorOnboardingEmailAdd[];
  emailFormControl:FormGroup;
  tempVendorId:string;
  tempEmailLinkRefId:string;
  backToSearchData = null;
  emailPopUpModel={
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }]
    ]
  }
  tmpEditTaxId:any;
  tmpEditVendorName:any;
  tmpEditVendorAddress:any;
  tmpEditMSAAgreementDate:any;
  isMSAEditTemplateWarning:boolean=false;
tmpEditPoAgreementDate:string;
tmpEditcontractStartDate:string;
tmpEditEstContractEndDate:string;
tmpEditInvoiceTermsId:number;
tmpEditInsuranceExhibitId:string;
tmpEditTaxIdNumber: string;
tmpEditClientName:string;
tmpEditClientAddress:string;
tmpEditRateToContractor:number;
tmpEditMSATypeId:number;
//tmpPaymentTermsId:string;
  validationErrorMessage:string;
  breadcrumbTitle:string; 
  pageHeader:string;
  specialPOTemplateForUpdate:any="";
  previewSpecialPOTemplate:boolean=false;
  specialNCATemplateForUpdate:any="";
  previewSpecialNCATemplate:boolean=false;
  isSpecialC2C: boolean = false;
  isSpecial1099: boolean = false;
  tmpSaveMsaAgreementDate: string;
  tmpSavePoAgreementDate: string;
  tmpSavecontractStartDate: string;
  tmpSaveEstContractEndDate: string;
  tmpSaveNcaAgreementDate: string;
  tmpSaveVendorCategoryId: number;
  tmpSaveInvoiceTermsId: number;
  tmpSaveInsuranceExhibitId: string;
  tmpSaveVendorName: string;
  tmpSaveTaxIdNumber: string;
  tmpSaveAddressLine1: string;
  tmpSaveApplicantName: string;
  tmpSaveClientName: string;
  tmpSaveClientAddress: string;
  tnpSaveRateToContractor: number;
  tmpSaveMSATypeId: number;
  tmpPaymentTermsId: string;
  tmpSaveSSNNumber: string;
  linkValidityTypes: any[] = [];
  isSpecial:boolean=false;
  isMSAType1099:boolean=false;
  emailLinkValidityHoursId:number=null;
  emailLinkValidityHours:string;
  tmpMSATemplate:any;
  tmpNCATemplate:any;
  tmpPOTemplate:any;
  tmpEditApplicantName:any;
  tmpNCAEditAgreementDate:any;
  tmpEditTemplatePaymentTermsId:any;
  tmpEditSSNNumber:string;
  selectedDocumentTemplateList:any;
  isMSASelected: boolean = false;
  isPOSelected: boolean = false;
  isNCASelected: boolean = false;
  isVoidChequeSelected: boolean = false;
  isW9Selected: boolean = false;
  isI9Selected: boolean = false;
  isDDSelected: boolean = false;
  isCOISelected: boolean = false;
  isEVerificationSelected: boolean = false;
  vendorId:number;
  isVendorAvailable:boolean=false;
  onlyNCASelected:boolean =false;
  loadingSaveButton:boolean = false;

  constructor(private sharedService: SharedService,
    private registerService: RegisterService,   
    private messageService: MessageService,
    private fb:FormBuilder,private router: Router,
    public datePipe: DatePipe,
    public vendorOnboardingService:VendorOnboardingService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private spinner: NgxSpinnerService,
    private backToSearchService:BackToSearchService,
    private jwtService:JwtService,
    private dataService: DataService,
    ) { }

  ngOnInit(): void {
    window.scroll(0, 0);
    this.backToSearchService.getBackToSearchSharedData().subscribe(data => this.backToSearchData = data);
    this.spinner.show();
    this.checkViewPermission();
    this.initialSetup();
    this.getInvoiceTerms();
    this.getClientListForRegistration();
  this.getLoggedInUserProfile();
  this.getMSAType();
  this.getinsuranceExhibit();
  this.getPaymentTerms();  
  this.getlinkValidityTypes();
    const param = this.route.snapshot.paramMap.get('emailLinkRefId');
    if (param) {
      this.tempEmailLinkRefId = param;
    }
    setTimeout(() => {
     // this.tempVendorId='5';
    if(this.tempEmailLinkRefId!= null && this.tempEmailLinkRefId!="" && this.tempEmailLinkRefId!=undefined)
    {
      this.spinner.show();
      this.GetVendorOnboardProcess(this.tempEmailLinkRefId);
    }
    }, 2000);
    this.dataService.getSharedData().subscribe(data => this.selectedDocumentTemplateList = data);
    this.pageHeader= 'Vendor Onboarding';
    this.breadcrumbTitle= 'Vendor Onboarding';
    setTimeout(() => {
      if(this.selectedDocumentTemplateList !=0 && this.selectedDocumentTemplateList !=undefined )
        {
          this.pageHeader= 'Send Document Link';
          this.breadcrumbTitle= 'Send Document Link';
          this.isMSASelected = this.selectedDocumentTemplateList.isMSASelected;
          this.isPOSelected = this.selectedDocumentTemplateList.isPOSelected;
          this.isNCASelected = this.selectedDocumentTemplateList.isNCASelected;
          this.isVoidChequeSelected = this.selectedDocumentTemplateList.isVoidChequeSelected;
          this.isW9Selected = this.selectedDocumentTemplateList.isW9Selected;
          this.isI9Selected = this.selectedDocumentTemplateList.isI9Selected;
          this.isDDSelected = this.selectedDocumentTemplateList.isDDSelected;
          this.isCOISelected = this.selectedDocumentTemplateList.isCOISelected;
          this.isEVerificationSelected = this.selectedDocumentTemplateList.isEVerificationSelected;
          this.vendorId = this.selectedDocumentTemplateList.vendorId;
          this.isVendorAvailable = this.selectedDocumentTemplateList.vendorAvailable;
          if(!this.selectedDocumentTemplateList.isMSASelected && !this.selectedDocumentTemplateList.isPOSelected
            && !this.selectedDocumentTemplateList.isDDSelected && !this.selectedDocumentTemplateList.isVoidChequeSelected
            && !this.selectedDocumentTemplateList.isI9Selected && !this.selectedDocumentTemplateList.isW9Selected
            && !this.selectedDocumentTemplateList.isEVerificationSelected && !this.selectedDocumentTemplateList.isCOISelected)
            {
              this.onlyNCASelected =true;
            }
          //const vendorName = this.VendorOnboardingForm.get('vendorName');
         
          ///for existing vendor get values from company profile///////start/////////
          this.vendorOnboardingService.getVendorDetails(this.vendorId).subscribe((value:any) =>{
            this.VendorOnboardingForm = this.fb.group({
              vendorName: new FormControl(value.vendorName, [Validators.required]),
              taxIdNumber: new FormControl(value.taxIdNumber),
              msaAgreementDate: new FormControl(value.msaAgreementDate != null ? new Date(value.msaAgreementDate) : null),
              addressLine1: new FormControl(value.addressLine1),
              applicantName: new FormControl(value.applicantName),
              clientName:new FormControl(value.clientName),
              clientAddress:new FormControl(value.clientAddress),
              poAgreementDate:  new FormControl(value.poAgreementDate != null ? new Date(value.poAgreementDate) : null),
              contractStartDate:  new FormControl(value.contractStartDate != null ? new Date(value.contractStartDate) : null),
              estContractEndDate: new FormControl(value.estContractEndDate != null ? new Date(value.estContractEndDate) : null),
              rateToContractor: new FormControl(value.rateToContractor),
              ncaAgreementDate: new FormControl(value.ncaAgreementDate != null ? new Date(value.ncaAgreementDate) : null),
              ssnNumber:new FormControl(value.ssnNumber),
              contractAgreementDate:  new FormControl(value.poAgreementDate != null ? new Date(value.poAgreementDate) : null),
            
            });
            if(value.insuranceExhibitId != null && value.insuranceExhibitId != undefined){
              var arr=this.arrInsuranceExhibit.filter(item => item.lookupOrder == value.insuranceExhibitId);
              this.selectedExhibitTypeId =  arr[0];
             this.insuranceExhibitId=value.insuranceExhibitId;
             this.isInsuranceExhibit=true;
            }
            if(value.msaTypeId != null && value.msaTypeId != undefined){
              var arr=this.arrMSAType.filter(item => item.lookupOrder == value.msaTypeId);
              this.selectedMSATypeId =  arr[0];
              this.isMSAType=true;
              this.msaTypeId = value.msaTypeId;
              const taxIdNumber = this.VendorOnboardingForm.get('taxIdNumber');
              const ssnNumber = this.VendorOnboardingForm.get('ssnNumber');
              if(this.msaTypeId==MSAType.Standard1099 || this.msaTypeId==MSAType.Special1099){
                ssnNumber.setValidators([Validators.required,Validators.minLength(9)]);
                taxIdNumber.clearValidators();
                this.isMSAType1099=true;
              }
              else{
                taxIdNumber.setValidators([Validators.required,Validators.minLength(9)]);
                ssnNumber.clearValidators();
                this.isMSAType1099=false;
              }
              taxIdNumber.updateValueAndValidity();
              ssnNumber.updateValueAndValidity();
              if(this.msaTypeId==MSAType.Special1099 || this.msaTypeId==MSAType.SpecialC2C){
            this.isSpecial=true;
            if(this.isMSASelected)
            {
              this.isPaymentTermRequired = true;
            }
            
            if(this.msaTypeId==MSAType.Special1099){
              this.isSpecial1099=true;
              this.isSpecialC2C=false;
              }
              else if(this.msaTypeId==MSAType.SpecialC2C)
              {
                this.isSpecialC2C=true;
                this.isSpecial1099=false;
              }
            
              }
              else{
                this.isSpecial=false;
            this.isPaymentTermRequired=false;
            this.paymentTermsIds = [];
            this.selectedPaymentTerms = undefined;
            this.selectedPaymentTermsIds = '';
            this.selectedPaymentTermsEditIds = '';
            this.isSpecial1099=false;
            this.isSpecialC2C=false;
              }

            if(this.onlyNCASelected==true && (this.msaTypeId==MSAType.Standard1099 || this.msaTypeId==MSAType.Special1099)){
              this.emailFormControl=this.fb.group({ 
                emailBody:new FormControl("", [this.editorMaxLength(10000)]),
                applicantEmailId:new FormControl('', [Validators.pattern(VMSConstants.emailValidator)]),
                emailLinkValidityHoursId:new FormControl(null,[Validators.required]),
                emailLinkValidityHours:new FormControl(""),
                vendorOnboardingEmailAdd:new FormArray([this.fb.group({
                emailId: new FormControl('', [Validators.required,Validators.pattern(VMSConstants.emailValidator)]),
              })])
             
            });
            }

            else if(this.onlyNCASelected==true && (this.msaTypeId==MSAType.StandardC2C || this.msaTypeId==MSAType.SpecialC2C)){
              this.emailFormControl=this.fb.group({ 
                emailBody:new FormControl("", [this.editorMaxLength(10000)]),
                applicantEmailId:new FormControl('', [Validators.required, Validators.pattern(VMSConstants.emailValidator)]),
                emailLinkValidityHoursId:new FormControl(null,[Validators.required]),
                emailLinkValidityHours:new FormControl(""),
                vendorOnboardingEmailAdd:new FormArray([this.fb.group({
                emailId: new FormControl(''),
              })])
             
            }); 
            }

            else if(this.onlyNCASelected==false && (this.msaTypeId==MSAType.StandardC2C || this.msaTypeId==MSAType.SpecialC2C)){
            if(this.isNCASelected){
              this.emailFormControl=this.fb.group({ 
                emailBody:new FormControl("", [this.editorMaxLength(10000)]),
                applicantEmailId:new FormControl('', [Validators.required, Validators.pattern(VMSConstants.emailValidator)]),
                emailLinkValidityHoursId:new FormControl(null,[Validators.required]),
                emailLinkValidityHours:new FormControl(""),
                vendorOnboardingEmailAdd:new FormArray([this.fb.group({
                emailId: new FormControl('', [Validators.required, Validators.pattern(VMSConstants.emailValidator)]),
              })])
             
            }); 
            }
            else{
              this.emailFormControl=this.fb.group({ 
                emailBody:new FormControl("", [this.editorMaxLength(10000)]),
                applicantEmailId:new FormControl('', [Validators.pattern(VMSConstants.emailValidator)]),
                emailLinkValidityHoursId:new FormControl(null,[Validators.required]),
                emailLinkValidityHours:new FormControl(""),
                vendorOnboardingEmailAdd:new FormArray([this.fb.group({
                emailId: new FormControl('', [Validators.required, Validators.pattern(VMSConstants.emailValidator)]),
              })])
            }); 
            }
            }

            }



            this.companyService.getClientListForRegistration(value.vendorCategoryId).subscribe((data: any) => {
              if (data != null || data != undefined) {
                this.selectedClientRegistrationId = data;
                this.selectedClientValidOnRegistration = false;
            
                this.vendorCategoryId = value.vendorCategoryId;
              }
            });
            if(value.invoiceTermsId != null)
              {
                this.companyService.getInvoiceTerms(value.invoiceTermsId).subscribe((data: any) => {
                  this.selectedInvoiceTermsId = data;
                  this.invoiceTermsId = value.invoiceTermsId;
                  this.invoiceTermEnable = true;
                });
              }
           const vendorAddress = this.VendorOnboardingForm.get('addressLine1');
           const contractAgreementDate  = this.VendorOnboardingForm.get('contractAgreementDate');
           const applicantName = this.VendorOnboardingForm.get('applicantName');
           const clientName = this.VendorOnboardingForm.get('clientName');
           const clientAddress = this.VendorOnboardingForm.get('clientAddress');
           const contractStartDate  = this.VendorOnboardingForm.get('contractStartDate');
           const estContractEndDate  = this.VendorOnboardingForm.get('estContractEndDate');
           const rateToContractor  = this.VendorOnboardingForm.get('rateToContractor');
           vendorAddress.clearValidators();
           contractAgreementDate.clearValidators();
           applicantName.clearValidators();
           clientName.clearValidators();
           clientAddress.clearValidators();
           contractStartDate.clearValidators();
           estContractEndDate.clearValidators();
           rateToContractor.clearValidators();
           this.vendorNameAvail=false;
           this.isMSATemplateGenerated=true;
           this.isPOTemplateGenerated=true;
           this.isNCATemplateGenerated=true;
           this.isSaveAvailable = true;
           if(this.isMSASelected)
           {
            this.isSaveAvailable = true;
            this.isMSATemplateGenerated=false;
              //vendorName.setValidators([Validators.required]);
              vendorAddress.setValidators([Validators.required]);
              contractAgreementDate.setValidators([Validators.required]);
              vendorAddress.updateValueAndValidity();
              contractAgreementDate.updateValueAndValidity();
           }
           if(this.isPOSelected)
           {
             this.isSaveAvailable = true;
             this.isPOTemplateGenerated=false;
             vendorAddress.setValidators([Validators.required]);
             contractAgreementDate.setValidators([Validators.required]);
             applicantName.setValidators([Validators.required]);
             clientName.setValidators([Validators.required]);
             clientAddress.setValidators([Validators.required]);
             contractStartDate.setValidators([Validators.required]);
             //estContractEndDate.setValidators([Validators.required]);
             rateToContractor.setValidators([Validators.required]);
             
             vendorAddress.updateValueAndValidity();
             contractAgreementDate.updateValueAndValidity();
             applicantName.updateValueAndValidity();
             clientName.updateValueAndValidity();
             clientAddress.updateValueAndValidity();
             contractStartDate.updateValueAndValidity();
             //estContractEndDate.updateValueAndValidity();
             rateToContractor.updateValueAndValidity();
           }
           if(this.isNCASelected)
           {
             this.isSaveAvailable = true;
             this.isNCATemplateGenerated=false;
             vendorAddress.setValidators([Validators.required]);
             contractAgreementDate.setValidators([Validators.required]);
             applicantName.setValidators([Validators.required]);
             vendorAddress.updateValueAndValidity();
             contractAgreementDate.updateValueAndValidity();
             applicantName.updateValueAndValidity();
           }
          })
           ///for existing vendor get values from company profile///////end/////////
        }
    }, 2000);
  }
  ngOnDestroy():void { 
    this.dataService.setSharedData(null);
  this.selectedDocumentTemplateList=0;
  }
  initialSetup(){
    this.VendorOnboardingForm = this.fb.group({
      vendorName: new FormControl('', [Validators.required]),
      taxIdNumber: new FormControl(''),
      msaAgreementDate: new FormControl(new Date()),
      addressLine1: new FormControl('', [Validators.required]),
      applicantName: new FormControl('', [Validators.required]),
      clientName:new FormControl('', [Validators.required]),
      clientAddress:new FormControl('', [Validators.required]),
      poAgreementDate:  new FormControl(new Date()),
      contractStartDate:  new FormControl(null, [Validators.required]),
      estContractEndDate: new FormControl(''),
      rateToContractor: new FormControl('',[Validators.required, Validators.pattern(VMSConstants.noZeroValidator)]),
      ncaAgreementDate: new FormControl(''),
      ssnNumber:new FormControl(''),
      contractAgreementDate: new FormControl(new Date(), [Validators.required]),
    });
    this.emailFormControl=this.fb.group({ 
      emailBody:new FormControl("", [this.editorMaxLength(10000)]),
      applicantEmailId:new FormControl('', [Validators.pattern(VMSConstants.emailValidator)]),
      emailLinkValidityHoursId:new FormControl(null,[Validators.required]),
      emailLinkValidityHours:new FormControl(""),
      vendorOnboardingEmailAdd:new FormArray([this.fb.group({
      emailId: new FormControl('', [Validators.required,Validators.pattern(VMSConstants.emailValidator)]),
    })])
   
  });
  }
  get VendorOnboardingFormControl() {
    return this.VendorOnboardingForm.controls;
  }

  get emailLinkResendFormControl(){
    return this.emailFormControl.controls;
  }

  getMSAType() {
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.MSAType).subscribe((data: any) => {
      this.msaTypes = data;
      this.arrMSAType = data;
      this.spinner.hide();
    });
  }

  getMSATypeOnChange(event) {
    this.isMSAType = true;
    this.msaTypeId = event.value.lookupOrder;
    const taxIdNumber = this.VendorOnboardingForm.get('taxIdNumber');
    const ssnNumber = this.VendorOnboardingForm.get('ssnNumber');
    const applicantEmailId = this.emailFormControl.get('applicantEmailId');
    if (this.msaTypeId == MSAType.Standard1099 || this.msaTypeId == MSAType.Special1099) {
      ssnNumber.setValidators([Validators.required, Validators.minLength(9)]);
      taxIdNumber.clearValidators();
      taxIdNumber.setValue('');
      applicantEmailId?.clearValidators();
      applicantEmailId?.setValue('');
      this.isMSAType1099 = true;
    }
    else {
      taxIdNumber.setValidators([Validators.required, Validators.minLength(9)]);
      //applicantEmailId?.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)])
      if((this.isVendorAvailable && this.isNCASelected) || !this.isVendorAvailable)
        {
          applicantEmailId?.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)]);
        }
      ssnNumber.clearValidators();
      ssnNumber.setValue('');
      this.isMSAType1099 = false;
    }
    taxIdNumber.updateValueAndValidity();
    ssnNumber.updateValueAndValidity();
    applicantEmailId?.updateValueAndValidity();
    // const ncaAgreementDate = this.VendorOnboardingForm.get('ncaAgreementDate');

    // if(this.msaTypeId==MSAType.Standard1099 || this.msaTypeId==MSAType.Special1099){
    //   this.isNCA=true;
    //   this.isNCATemplateGenerated=false;
    //   ncaAgreementDate.setValidators([Validators.required]);
    //   this.showPaymentTerms =true;
    // }
    // else{
    //   this.isNCA=false;
    //   this.isNCATemplateGenerated=true;
    //   ncaAgreementDate.clearValidators();
    // }
    // ncaAgreementDate.updateValueAndValidity();
    if (this.msaTypeId == MSAType.Special1099 || this.msaTypeId == MSAType.SpecialC2C) {
      this.isSpecial = true;
      if (this.paymentTermsIds.length == 0) {
        this.isPaymentTermRequired = true;
      }
      else {
        this.isPaymentTermRequired = false;
      }
      if (this.msaTypeId == MSAType.Special1099) {
        this.isSpecial1099 = true;
        this.isSpecialC2C = false;
      }
      else if (this.msaTypeId == MSAType.SpecialC2C) {
        this.isSpecialC2C = true;
        this.isSpecial1099 = false;
      }
    }
    else {
      this.isSpecial = false;
      this.isPaymentTermRequired = false;
      this.paymentTermsIds = [];
      this.selectedPaymentTerms = undefined;
      this.selectedPaymentTermsIds = '';
      this.selectedPaymentTermsEditIds = '';
      this.isSpecial1099 = false;
      this.isSpecialC2C = false;
    }
  }
  getinsuranceExhibit(){
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.InsuranceExhibitA).subscribe((data: any) => {
      this.insuranceExhibit = data;
      this.arrInsuranceExhibit=data;

    });
  }
  getinsuranceExhibiOnChange(event) {
    this.isInsuranceExhibit = true;
    this.insuranceExhibitId = event.value.lookupOrder;
  }

  preventSqlComments(event) {
    let avoidString: Array<string> = ['DELETE', 'ADD', 'UPDATE', 'TABLE', 'INSERT'];
    let name = event.target.value.toUpperCase();
    console.log(name);
    if (avoidString.includes(name)) {
      this.isSqlComments = true;
    }
    else {
      this.isSqlComments = false;
    }
  }

  getLoggedInUserProfile()
  {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
  }

  onVendorAvailabilityCheck(){
    //Standard and special C2C only have a taxID
    if(this.msaTypeId==MSAType.StandardC2C || this.msaTypeId==MSAType.SpecialC2C){
     this.taxIdNumber = this.VendorOnboardingForm.controls['taxIdNumber'].value;
     this.vendorName = this.VendorOnboardingForm.controls['vendorName'].value;
     this.taxIdNumberLength = this.VendorOnboardingForm.controls['taxIdNumber'].value.length;
    if(!this.isVendorAvailable)
    {
      if (this.vendorName != '' ) { 
        this.registerService.onVendorNameCheck(this.vendorName).subscribe((data: any) => {
          this.vendorNameAvail = data;
        });
      }
    }
    
    if (this.taxIdNumberLength == 9 && this.taxIdNumber != '' && this.vendorName != '') {
      this.registerService.onVendorAvailabilityCheck(this.vendorName, this.taxIdNumber, 0).subscribe((data: any) => {
        if (data == true) {
          this.isVendorAvailability = false;
          this.messageService.add({ key: 'bc', severity: 'error', summary: 'Error', detail: 'Already company exists in this State with this TaxId' });
        }
        else {
          this.isVendorAvailability = true;
          this.isSaveAvailable = true;
        }

      });
    }
   
    else if (this.taxIdNumberLength < 9) {
      this.isSaveAvailable = false;
    }
  }
  else{
    this.isSaveAvailable = true;
  }
  }
  onCheckTaxIdNumber(){
    var taxIdNumber = this.VendorOnboardingForm.controls['taxIdNumber'].value;
    var taxIdNumberLength = this.VendorOnboardingForm.controls['taxIdNumber'].value.length;
    if (taxIdNumberLength == 9)
    {
      this.registerService.onTaxIdNumberCheck(taxIdNumber).subscribe((data: any) => {
        this.taxIdAvail = data;
      });
    } 
  }
  numericInputOnly(event: any) {
    const reg = /^-?\d*(\.\d{0,2})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }
  getClientListForRegistration() {
    this.categoryName = 'Client List For Registration';
    this.sharedService.getLookupCategory(this.categoryName).subscribe((data: any) => {
      this.arrClientListForRegistration=data;
      this.clientListForRegistration = this.arrClientListForRegistration.sort((a, b) => (a.lookupOrder < b.lookupOrder) ? -1 : 1);
      this.vendorCategoryId = this.clientListForRegistration[0].lookupOrder;
    });
  }
  getClientListForRegistrationOnChange(event) {
    this.isValidateVendorCategory = true;
    this.vendorCategoryId = event.value.lookupOrder;
    this.selectedClientValidOnRegistration = false;
  }
  getInvoiceTermsOnChange(event) {
    this.invoiceTermEnable = true;
    this.invoiceTermsId = event.value.lookupOrder;
  }
  getInvoiceTerms() { 
    this.categoryName = 'Invoice Terms';
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.InvoiceTerms).subscribe((data: any) => {
      this.arrInvoiceTerms = data;
      this.invoiceTerms = this.arrInvoiceTerms.sort((a, b) => (a.lookupOrder < b.lookupOrder) ? -1 : 1);
      this.invoiceTermsId = this.invoiceTerms[0].lookupOrder;
    });
  }
  save({value}: {value : VendorOnboarding}){
    this.loadingSaveButton = true;
    if(this.isVendorAvailable)
    {
      value.vendorId= this.vendorId;
      value.isMSASelected=this.isMSASelected;
      value.isPOSelected=this.isPOSelected;
      value.isNCASelected=this.isNCASelected;
      value.isCOISelected=this.isCOISelected;
      value.isDDSelected=this.isDDSelected;
      value.isW9Selected=this.isW9Selected;
      value.isI9Selected=this.isI9Selected;
      value.isVoidChequeSelected=this.isVoidChequeSelected;
      value.isEVerificationSelected=this.isEVerificationSelected;
      value.isVendorAvailable=true;
    }
    this.spinner.show();
    if(this.isMSASelected)
    {
      value.msaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    }
    if(this.isPOSelected)
    {
      value.poAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    }
    if(this.isNCASelected)
    {
      value.ncaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    }
    if(!this.isVendorAvailable)
      {
        value.msaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
        value.poAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
       value.ncaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
      }
    //value.msaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    //value.poAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    value.contractStartDate=this.datePipe.transform(value.contractStartDate, 'yyyy-MM-dd');
    value.estContractEndDate=this.datePipe.transform(value.estContractEndDate, 'yyyy-MM-dd');
    value.vendorCategoryId=this.vendorCategoryId;
    value.invoiceTermsId=this.invoiceTermsId;
    value.insuranceExhibitId=this.insuranceExhibitId;
    value.createdBy=Number(this.loggedInUserProfile.uid);
    value.createdOn=new Date();
    value.msaTypeId=this.msaTypeId;
    value.poDocTemplate=this.poTemplate;
    value.msaDocTemplate=this.msaTemplate;
    value.ncaDocTemplate=this.ncaTemplate;
  value.emailBody=(this.emailFormControl.controls['emailBody'].value == null ? null : this.emailFormControl.controls['emailBody'].value);
  value.emailIds = this.emailFormControl.controls['vendorOnboardingEmailAdd'].value.map(element => element.emailId).join(",");
  value.applicantEmailId=(this.emailFormControl.controls['applicantEmailId'].value == null ? null : this.emailFormControl.controls['applicantEmailId'].value);
  value.comments=(this.emailFormControl.controls['emailBody'].value == null ? null : this.emailFormControl.controls['emailBody'].value);
  value.emailLinkValidityHoursId = this.emailLinkValidityHoursId;
  value.emailLinkValidityHours = this.emailLinkValidityHours;
  if (this.vendorOnboardingEditId == true) {
    value.templatePaymentTermsId = this.selectedPaymentTermsEditIds;
  }
  else {
    value.templatePaymentTermsId = this.selectedPaymentTermsIds;
  }
  if(this.tmpPaymentTermsId == "" || this.tmpPaymentTermsId == undefined)
    {
      this.tmpPaymentTermsId=null;
    }
    if(value.templatePaymentTermsId == "" || value.templatePaymentTermsId == undefined)
      {
        value.templatePaymentTermsId=null;
      }
  if(!this.isVendorAvailable || this.isVendorAvailable &&(this.isMSASelected || this.isPOSelected || this.isNCASelected)){
    
    if(this.tmpSaveMsaAgreementDate!=value.msaAgreementDate || this.tmpSavePoAgreementDate!=value.poAgreementDate || 
      this.tmpSavecontractStartDate!=value.contractStartDate || this.tmpSaveEstContractEndDate!=value.estContractEndDate || 
      this.tmpSaveNcaAgreementDate!=value.ncaAgreementDate || this.tmpSaveVendorCategoryId!=value.vendorCategoryId || 
      this.tmpSaveInvoiceTermsId!=value.invoiceTermsId || this.tmpSaveInsuranceExhibitId!=value.insuranceExhibitId || 
      this.tmpSaveVendorName!=value.vendorName || this.tmpSaveTaxIdNumber!=value.taxIdNumber || 
      this.tmpSaveAddressLine1!=value.addressLine1 || this.tmpSaveApplicantName!=value.applicantName || 
      this.tmpSaveClientName!=value.clientName || this.tmpSaveClientAddress!=value.clientAddress || 
      this.tnpSaveRateToContractor!=value.rateToContractor || this.tmpSaveMSATypeId!=value.msaTypeId || 
      this.tmpPaymentTermsId!=value.templatePaymentTermsId || value.ncaAgreementDate !=this.tmpSaveNcaAgreementDate || this.tmpSaveSSNNumber !=value.ssnNumber){
  
      this.tmpSaveMsaAgreementDate=value.msaAgreementDate;
      this.tmpSavePoAgreementDate=value.poAgreementDate;
      this.tmpSavecontractStartDate=value.contractStartDate;
      this.tmpSaveEstContractEndDate=value.estContractEndDate;
      this.tmpSaveNcaAgreementDate=value.ncaAgreementDate
      this.tmpSaveVendorCategoryId=value.vendorCategoryId;
      this.tmpSaveInvoiceTermsId=value.invoiceTermsId
      this.tmpSaveInsuranceExhibitId=value.insuranceExhibitId
      this.tmpSaveVendorName=value.vendorName;
      this.tmpSaveTaxIdNumber=value.taxIdNumber;
      this.tmpSaveAddressLine1=value.addressLine1;
      this.tmpSaveApplicantName=value.applicantName;
      this.tmpSaveClientName=value.clientName;
      this.tmpSaveClientAddress=value.clientAddress;
      this.tnpSaveRateToContractor=value.rateToContractor;
      this.tmpSaveMSATypeId=value.msaTypeId;
      this.tmpPaymentTermsId=value.templatePaymentTermsId;
      this.tmpSaveSSNNumber =value.ssnNumber;
      if(!this.isVendorAvailable)
      {
        this.isNCATemplateGenerated=false;
        this.isMSATemplateGenerated=false;
        this.isPOTemplateGenerated=false;
      }
      if(this.isVendorAvailable)
      {
        this.isNCATemplateGenerated=true;
        this.isMSATemplateGenerated=true;
        this.isPOTemplateGenerated=true;
      }
      if(this.isVendorAvailable && this.isMSASelected)
      {
        this.isMSATemplateGenerated=false;
      }
      if(this.isVendorAvailable && this.isNCASelected)
      {
        this.isNCATemplateGenerated=false;
      }
      if(this.isVendorAvailable && this.isPOSelected)
      {
        this.isPOTemplateGenerated=false;
      }     
        // if(this.msaTypeId==MSAType.Standard1099 || this.msaTypeId==MSAType.Special1099){
        //   this.isNCATemplateGenerated=false;
        // }
        // else{
        //   this.isNCATemplateGenerated=true;
        // }
        this.validationErrorMessage="One or more field(s) has been edited. Please generate all the templates (MSA, PO and NCA) again to submit the vendor onboarding record"
      this.isMSAEditTemplateWarning=true;
      this.loadingSaveButton = false;
        this.spinner.hide();
        return;
      }
  }

  
  
  this.vendorOnboardingService.InitiateVendorOnboardProcess(value).subscribe((data: any) => {
    this.loadingSaveButton = false;
    this.clear()
    if(this.isSpecial){
      this.messageService.add({key:'save', severity:'success', summary:'Confirmed', detail:'The details have been submitted to the approver'});
      setTimeout(()=>{ 
        this.spinner.hide();
        this.router.navigate(['/dashboard/admin']);
      }, 2000);
    }
    else{
      if(this.isPOSelected || this.isNCASelected){
        this.messageService.add({key:'save', severity:'success', summary:'Confirmed', detail:'The details have been submitted to the approver'});
      }
      else{
        this.messageService.add({key:'save', severity:'success', summary:'Confirmed', detail:'The email link has been shared with the vendor successfully'})
      }
      setTimeout(()=>{ 
        this.spinner.hide();
        if(this.pageHeader== 'Vendor Onboarding')
          {
            this.router.navigate(['/admin/vendor-onboard-approval-search']);
          }
          else{
            this.dataService.setSharedData(null);
            this.selectedDocumentTemplateList=0;
            this.router.navigate(['/users/vendor-search']);
          }
       // this.router.navigate(['/admin/vendor-onboard-approval-search']);
      }, 2000);
    }
    
    this.spinner.hide();
    
  });
  
  }
  update({value}: {value : VendorOnboarding}){
    this.spinner.show();
    if(this.isVendorAvailable)
      {
        value.vendorId= this.vendorId;
        value.isMSASelected=this.isMSASelected;
        value.isPOSelected=this.isPOSelected;
        value.isNCASelected=this.isNCASelected;
        value.isCOISelected=this.isCOISelected;
        value.isDDSelected=this.isDDSelected;
        value.isW9Selected=this.isW9Selected;
        value.isI9Selected=this.isI9Selected;
        value.isVoidChequeSelected=this.isVoidChequeSelected;
        value.isEVerificationSelected=this.isEVerificationSelected;
        value.isVendorAvailable=true;
      }
    if (this.vendorOnboardingEditId == true) {
      value.templatePaymentTermsId = this.selectedPaymentTermsEditIds;
    }
    else {
      value.templatePaymentTermsId = this.selectedPaymentTermsIds;
    }
    if(this.isMSASelected)
      {
        value.msaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
      }
      if(this.isPOSelected)
      {
        value.poAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
      }
      if(this.isNCASelected)
      {
        value.ncaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
      }
      if(!this.isVendorAvailable)
        {
          value.msaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
          value.poAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
         value.ncaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
        }
    //value.msaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    //value.ncaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    // if(value.vendorName != this.tmpEditVendorName || value.addressLine1 != this.tmpEditVendorAddress ||value.taxIdNumber != this.tmpEditTaxId ||value.msaAgreementDate != this.tmpEditMSAAgreementDate ||this.tmpEditTemplatePaymentTermsId!=value.templatePaymentTermsId)
    // {
    //   this.validationErrorMessage="Please generate the MSA template to save/update the changes";
    //   this.isMSAEditTemplateWarning=true;
    //   this.spinner.hide();
    //   return;
    // }
    // if((value.applicantName != this.tmpEditApplicantName || value.ncaAgreementDate !=this.tmpNCAEditAgreementDate) ){
    //   this.validationErrorMessage="Please generate the NCA template to save/update the changes";
    //   this.isMSAEditTemplateWarning=true;
    //   this.spinner.hide();
    //   return;
    // }
    
    //value.poAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    value.contractStartDate=this.datePipe.transform(value.contractStartDate, 'yyyy-MM-dd');
    value.estContractEndDate=this.datePipe.transform(value.estContractEndDate, 'yyyy-MM-dd');
    value.ncaAgreementDate=this.datePipe.transform(value.ncaAgreementDate, 'yyyy-MM-dd');
    value.vendorCategoryId=this.vendorCategoryId;
    value.invoiceTermsId=this.invoiceTermsId;
    value.insuranceExhibitId=this.insuranceExhibitId;
    value.modifiedBy=Number(this.loggedInUserProfile.uid);
    value.createdOn=new Date();
    value.msaTypeId=this.msaTypeId;
    if(!this.isVendorAvailable || this.isVendorAvailable &&(this.isMSASelected || this.isPOSelected || this.isNCASelected))
    {
      if(this.tmpEditMSAAgreementDate!=value.msaAgreementDate || this.tmpEditPoAgreementDate!=value.poAgreementDate || 
        this.tmpEditcontractStartDate!=value.contractStartDate || this.tmpEditEstContractEndDate!=value.estContractEndDate || 
        this.tmpNCAEditAgreementDate!=value.ncaAgreementDate  ||  this.tmpEditVendorName!=value.vendorName || 
        this.tmpEditTaxId!=value.taxIdNumber || this.tmpEditVendorAddress!=value.addressLine1 || 
        this.tmpEditApplicantName!=value.applicantName || this.tmpEditClientName!=value.clientName || 
        this.tmpEditClientAddress!=value.clientAddress || this.tmpEditRateToContractor!=value.rateToContractor || 
        this.tmpEditMSATypeId!=value.msaTypeId || this.tmpEditTemplatePaymentTermsId!=value.templatePaymentTermsId || 
        value.ncaAgreementDate !=this.tmpNCAEditAgreementDate || this.tmpEditSSNNumber!=value.ssnNumber){
        if(!this.isVendorAvailable)
          {
            this.isNCATemplateGenerated=false;
            this.isMSATemplateGenerated=false;
            this.isPOTemplateGenerated=false;
          }
          if(this.isVendorAvailable)
          {
            this.isNCATemplateGenerated=true;
            this.isMSATemplateGenerated=true;
            this.isPOTemplateGenerated=true;
          }
          if(this.isVendorAvailable && this.isMSASelected)
          {
            this.isMSATemplateGenerated=false;
          }
          if(this.isVendorAvailable && this.isNCASelected)
          {
            this.isNCATemplateGenerated=false;
          }
          if(this.isVendorAvailable && this.isPOSelected)
          {
            this.isPOTemplateGenerated=false;
          }     
        this.validationErrorMessage="One or more field(s) has been edited. Please generate all the templates (MSA, PO and NCA) again to submit the vendor onboarding record"
  this.isMSAEditTemplateWarning=true;
    this.spinner.hide();
    return;
      }
    }
    
    //Update NCA Template
    // this.vendorOnboardingService.GenerateNCATemplate(value).subscribe((ncaData: any) => {
    //   this.ncaTemplate=ncaData.result;
      //Upadate PO Template
      //this.vendorOnboardingService.GeneratePOTemplate(value).subscribe((poData: any) => {
        //this.poTemplate=poData.result;
        value.poDocTemplate=this.poTemplate;
        value.msaDocTemplate=this.msaTemplate;
        value.ncaDocTemplate=this.ncaTemplate;
        value.emailBody=(this.emailFormControl.controls['emailBody'].value == null ? null : this.emailFormControl.controls['emailBody'].value);
        value.emailIds = this.emailFormControl.controls['vendorOnboardingEmailAdd'].value.map(element => element.emailId).join(",");
        value.comments=(this.emailFormControl.controls['emailBody'].value == null ? null : this.emailFormControl.controls['emailBody'].value);
        value.emailLinkValidityHoursId = this.emailLinkValidityHoursId;
        value.emailLinkValidityHours = this.emailLinkValidityHours;
        value.tempVendorId=Number(this.tempVendorId);

        this.vendorOnboardingService.UpdateVendorOnboardProcess(value).subscribe((data: any) => {
          this.messageService.add({key:'save', severity:'success', summary:'Confirmed', detail:'The vendor:'+this.tmpEditVendorName+' enrolment details have been successfully updated'});
          // this.router.navigate(['/admin/vendor-onboard-process-search']);
          this.spinner.hide();
          if (this.backToSearchData != null) {
            this.backToSearchData.fromPage = 'Edit Vendor Onboarding Page';
            this.backToSearchData.toPage = 'Vendor Onboard Process Search Page';
            this.backToSearchService.setBackToSearchSharedData(this.backToSearchData);
          }
          setTimeout(()=>{ 
            this.spinner.hide();
            if(this.pageHeader== 'Vendor Onboarding')
              {
                this.router.navigate(['/admin/vendor-onboard-approval-search']);
              }
              else{
                this.dataService.setSharedData(null);
                this.selectedDocumentTemplateList=0;
                this.router.navigate(['/users/vendor-search']);
              }
        }, 2000);

        });
     // });
  //  });
    }
  onCancelVendorForm() {
    // this.router.navigate(['/dashboard/admin']);
    if (this.backToSearchData != null) {
      this.backToSearchData.fromPage = 'Edit Vendor Onboarding Page';
      this.backToSearchData.toPage = 'Vendor Onboard Process Search Page';
      this.backToSearchService.setBackToSearchSharedData(this.backToSearchData);
    }
    if(this.vendorOnboardingEditId ==true)
    {
      this.router.navigate(['/admin/vendor-onboard-process-search']);
    }
    else{
      this.dataService.setSharedData(null);
      this.selectedDocumentTemplateList=0;
      this.router.navigate(['/users/vendor-search']);
    }
  }
  onSelectContractStartDate(event) {
   
    const localDateString = event.toLocaleDateString('En-en');
    this.contractEndDate_Start = new Date(localDateString);
    this.VendorOnboardingForm.controls['estContractEndDate'].setValue(undefined);

  }

  backToDashboard(){
    this.router.navigate(['/dashboard/admin']);
  }

  generatePO({value}: {value : VendorOnboarding}){
    this.spinner.show();
    if(!this.isVendorAvailable)
    {
      value.msaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
      value.ncaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    }
    
    value.poAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    this.tmpSavePoAgreementDate=value.poAgreementDate;  
    value.contractStartDate=this.datePipe.transform(value.contractStartDate, 'yyyy-MM-dd');
    value.estContractEndDate=this.datePipe.transform(value.estContractEndDate, 'yyyy-MM-dd');
   
    value.vendorCategoryId=this.vendorCategoryId;
    value.invoiceTermsId=this.invoiceTermsId;
    value.insuranceExhibitId=this.insuranceExhibitId;
    value.createdBy=Number(this.loggedInUserProfile.uid);
    value.createdOn=new Date();
    value.msaTypeId=this.msaTypeId;
    if(value.msaTypeId==this.tmpEditMSATypeId && value.vendorName == this.tmpEditVendorName && value.addressLine1 == this.tmpEditVendorAddress &&value.taxIdNumber == this.tmpEditTaxId &&value.applicantName== this.tmpEditApplicantName && value.clientName==this.tmpEditClientName && value.clientAddress==this.tmpEditClientAddress && value.poAgreementDate ==this.tmpEditPoAgreementDate &&this.tmpEditcontractStartDate==value.contractStartDate && this.tmpEditEstContractEndDate ==value.estContractEndDate && value.rateToContractor==this.tmpEditRateToContractor && this.isPOTemplateGenerated==true && this.tmpEditSSNNumber==value.ssnNumber)
    {
      if(this.msaTypeId ==MSAType.SpecialC2C || this.msaTypeId == MSAType.Special1099)
      {
        this.previewSpecialPOTemplate=true;
        this.specialPOTemplateForUpdate = this.tmpPOTemplate;
      }
      else {
        if(this.isVendorAvailable)
          {
            this.previewSpecialPOTemplate=true;
            this.specialPOTemplateForUpdate = this.tmpPOTemplate;
          }
          else{
            this.isPOTemplateGenerated=true;
            this.previewTemplate=true;
            this.previewDocumentTemplate = this.sanitizer.bypassSecurityTrustHtml(this.tmpPOTemplate);
          }
      }
      this.spinner.hide();
      return
    }
    if(this.vendorOnboardingEditId ==true){
//       this.tmpEditVendorName=value.vendorName;
// this.tmpEditTaxId=value.taxIdNumber;
// this.tmpEditVendorAddress=value.addressLine1;
// this.tmpEditMSAAgreementDate=this.datePipe.transform(value.msaAgreementDate, 'yyyy-MM-dd');
// this.tmpEditTemplatePaymentTermsId=value.templatePaymentTermsId;
//       this.tmpEditMSATypeId=value.msaTypeId;
// this.tmpEditClientName=value.clientName;
// this.tmpEditClientAddress=value.clientAddress;
// this.tmpEditPoAgreementDate=this.datePipe.transform(value.poAgreementDate, 'yyyy-MM-dd');
// this.tmpEditcontractStartDate=this.datePipe.transform(value.contractStartDate, 'yyyy-MM-dd');
// this.tmpEditEstContractEndDate=this.datePipe.transform(value.estContractEndDate, 'yyyy-MM-dd');
// this.tmpEditRateToContractor=value.rateToContractor;
// this.tmpEditSSNNumber=value.ssnNumber;
    }
    if(this.isVendorAvailable && !this.isMSASelected)
    {
       this.storeExistingDetails(value);
    }
    //this.companyNotesDescriptionContainer.nativeElement.innerHTML=this.msaTemplate;
    this.vendorOnboardingService.GeneratePOTemplate(value).subscribe((data: any) => {
      // this.messageService.add({key:'save', severity:'success', detail:'PO generated successfully'});
      // //console.log(data.result);
       this.poTemplate=data.result;
      // this.previewTemplate=true;
      // this.isPOTemplateGenerated=true;
      // this.previewDocumentTemplate = this.sanitizer.bypassSecurityTrustHtml(this.poTemplate);
      //this.companyNotesDescriptionContainer.nativeElement.innerHTML=this.poTemplate;
      if(this.msaTypeId ==MSAType.SpecialC2C || this.msaTypeId == MSAType.Special1099)
      {
        console.log(data.result);
        this.previewSpecialPOTemplate=true;
        this.specialPOTemplateForUpdate = data.result;
        //console.log(this.specialMSATemplateForUpdate);
      }
      else {
        if(this.isVendorAvailable)
          {
            this.previewSpecialPOTemplate=true;
            this.specialPOTemplateForUpdate = data.result;
          }
          else{
            this.messageService.add({key:'save', severity:'success', detail:'PO generated successfully'});
            this.isPOTemplateGenerated=true;
            this.previewTemplate=true;
            this.previewDocumentTemplate = this.sanitizer.bypassSecurityTrustHtml(this.poTemplate);
          }
         //console.log(this.previewDocumentTemplate);
        //this.companyNotesDescriptionContainer.nativeElement.innerHTML=this.msaTemplate;
      }
      this.spinner.hide();
    
    });
}

generateMSA({value}: {value : VendorOnboarding}){
  
  this.spinner.show();
  if(!this.isVendorAvailable)
  {
    value.poAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    value.ncaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
  }
value.msaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
this.tmpSaveMsaAgreementDate=value.msaAgreementDate;
value.contractStartDate=this.datePipe.transform(value.contractStartDate, 'yyyy-MM-dd');
value.estContractEndDate=this.datePipe.transform(value.estContractEndDate, 'yyyy-MM-dd');

value.vendorCategoryId=this.vendorCategoryId;
value.invoiceTermsId=this.invoiceTermsId;
value.insuranceExhibitId=this.insuranceExhibitId;
value.createdBy=Number(this.loggedInUserProfile.uid);
value.createdOn=new Date();
value.msaTypeId=this.msaTypeId;
if (this.vendorOnboardingEditId == true) {
  value.templatePaymentTermsId = this.selectedPaymentTermsEditIds;
}
else {
  value.templatePaymentTermsId = this.selectedPaymentTermsIds;
}
//on Edit section - no changes then old template should papulate
if(value.vendorName == this.tmpEditVendorName && value.addressLine1 == this.tmpEditVendorAddress &&value.taxIdNumber == this.tmpEditTaxId &&value.msaAgreementDate == this.tmpEditMSAAgreementDate &&this.tmpEditTemplatePaymentTermsId==value.templatePaymentTermsId && this.isMSATemplateGenerated==true && this.tmpEditSSNNumber==value.ssnNumber)
    {
      if(this.msaTypeId ==MSAType.SpecialC2C || this.msaTypeId == MSAType.Special1099)
      {
        this.previewSpecialMSATemplate=true;
        this.specialMSATemplateForUpdate = this.tmpMSATemplate;
      }
      else {
        if(this.isVendorAvailable){
          this.previewSpecialMSATemplate=true;
          this.specialMSATemplateForUpdate = this.tmpMSATemplate;
        }
        else{
          this.isMSATemplateGenerated=true;
          this.previewTemplate=true;
          var MSAOnPreview = this.tmpMSATemplate.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
          this.previewDocumentTemplate = this.sanitizer.bypassSecurityTrustHtml(MSAOnPreview);
        }
      }
      this.spinner.hide();
      return
    }
    else{
      //if(this.vendorOnboardingEditId==true){
      if(this.isVendorAvailable){
        if(this.isPOSelected){
          this.isPOTemplateGenerated = false;
        }
        if(this.isNCASelected){
          this.isNCATemplateGenerated = false;
        }
      }
      else{
          this.isPOTemplateGenerated = false;
          this.isNCATemplateGenerated = false;
      }
    //}
    }
if(this.vendorOnboardingEditId==true){
// this.tmpEditVendorName=value.vendorName;
// this.tmpEditTaxId=value.taxIdNumber;
// this.tmpEditVendorAddress=value.addressLine1;
// this.tmpEditMSAAgreementDate=this.datePipe.transform(value.msaAgreementDate, 'yyyy-MM-dd');
// this.tmpEditTemplatePaymentTermsId=value.templatePaymentTermsId;
// this.tmpEditSSNNumber=value.ssnNumber;
}
   this.storeExistingDetails(value);


this.vendorOnboardingService.GenerateMSATemplate(value).subscribe((data: any) => {
  this.msaTemplate=data.result;
  if(this.msaTypeId ==MSAType.SpecialC2C || this.msaTypeId == MSAType.Special1099)
  {
    this.previewSpecialMSATemplate=true;
    this.specialMSATemplateForUpdate = data.result;
    //console.log(this.specialMSATemplateForUpdate);
  }
  else {
    if(this.isVendorAvailable){
      this.previewSpecialMSATemplate=true;
    this.specialMSATemplateForUpdate = data.result;
    }
    else{
      this.messageService.add({key:'save', severity:'success', detail:'MSA generated successfully'});
      this.isMSATemplateGenerated=true;
      this.previewTemplate=true;
      var MSAOnPreview = this.msaTemplate.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
      this.previewDocumentTemplate = this.sanitizer.bypassSecurityTrustHtml(MSAOnPreview);
    }
    //console.log(this.previewDocumentTemplate);
    //this.companyNotesDescriptionContainer.nativeElement.innerHTML=this.msaTemplate;
  }
  this.spinner.hide();
});

}
generateNCA({value}: {value : VendorOnboarding}){
  this.spinner.show();
  if(!this.isVendorAvailable)
    {
      value.poAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
      value.msaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    }
  value.contractStartDate=this.datePipe.transform(value.contractStartDate, 'yyyy-MM-dd');
  value.estContractEndDate=this.datePipe.transform(value.estContractEndDate, 'yyyy-MM-dd');
  value.ncaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
  this.tmpSaveNcaAgreementDate=value.ncaAgreementDate;
  value.vendorCategoryId=this.vendorCategoryId;
  value.invoiceTermsId=this.invoiceTermsId;
  value.insuranceExhibitId=this.insuranceExhibitId;
  value.createdBy=Number(this.loggedInUserProfile.uid);
  value.createdOn=new Date();
  value.msaTypeId=this.msaTypeId;
  if(value.applicantName == this.tmpEditApplicantName && value.ncaAgreementDate == this.tmpNCAEditAgreementDate && this.isNCATemplateGenerated==true)
  {
    // this.isNCATemplateGenerated=true;
    // this.previewTemplate=true;
    // this.previewDocumentTemplate = this.sanitizer.bypassSecurityTrustHtml(this.tmpNCATemplate);
    if(this.msaTypeId ==MSAType.SpecialC2C || this.msaTypeId == MSAType.Special1099)
    {
      this.previewSpecialNCATemplate=true;
      this.specialNCATemplateForUpdate = this.tmpNCATemplate;
    }
    else {
      if(this.isVendorAvailable){
        this.previewSpecialNCATemplate=true;
        this.specialNCATemplateForUpdate = this.tmpNCATemplate;
      }
      else{
        this.isNCATemplateGenerated=true;
        this.previewTemplate=true;
        this.previewDocumentTemplate = this.sanitizer.bypassSecurityTrustHtml(this.tmpNCATemplate);
      }
    }
    this.spinner.hide();
    return;
    
  }
  if(this.vendorOnboardingEditId==true ){
    // this.tmpEditApplicantName=value.applicantName;
    // this.tmpNCAEditAgreementDate=this.datePipe.transform(value.ncaAgreementDate, 'yyyy-MM-dd');
  }
  if(this.isVendorAvailable && !this.isMSASelected && !this.isPOSelected)
  {
    console.log('ddd');
      this.storeExistingDetails(value);
  }
  this.vendorOnboardingService.GenerateNCATemplate(value).subscribe((data: any) => {
    //this.messageService.add({key:'save', severity:'success', detail:'NCA generated successfully'});
    this.ncaTemplate=data.result;
    //this.isNCATemplateGenerated=true;
    //this.previewTemplate=true;
    //this.previewDocumentTemplate = this.sanitizer.bypassSecurityTrustHtml(this.ncaTemplate);
    //this.companyNotesDescriptionContainer.nativeElement.innerHTML=this.ncaTemplate;
    if(this.msaTypeId ==MSAType.SpecialC2C || this.msaTypeId == MSAType.Special1099)
    {
      this.previewSpecialNCATemplate=true;
      this.specialNCATemplateForUpdate = data.result;
    }
    else {
      if(this.isVendorAvailable){
        this.previewSpecialNCATemplate=true;
        this.specialNCATemplateForUpdate = data.result;
      }
      else{
        this.messageService.add({key:'save', severity:'success', detail:'NCA generated successfully'});
        this.isNCATemplateGenerated=true;
        this.previewTemplate=true;
        this.previewDocumentTemplate = this.sanitizer.bypassSecurityTrustHtml(this.ncaTemplate);
      }
    }
    this.spinner.hide();
  
  });
}
storeExistingDetails(value : VendorOnboarding)
{
  console.log('store',value)
  this.tmpSaveMsaAgreementDate=value.msaAgreementDate;
  this.tmpSavePoAgreementDate=value.poAgreementDate;
  this.tmpSavecontractStartDate=value.contractStartDate;
  this.tmpSaveEstContractEndDate=value.estContractEndDate;
  this.tmpSaveNcaAgreementDate=value.ncaAgreementDate
  this.tmpSaveVendorCategoryId=value.vendorCategoryId;
  this.tmpSaveInvoiceTermsId=value.invoiceTermsId
  this.tmpSaveInsuranceExhibitId=value.insuranceExhibitId
  this.tmpSaveVendorName=value.vendorName;
  this.tmpSaveTaxIdNumber=value.taxIdNumber;
  this.tmpSaveAddressLine1=value.addressLine1;
  this.tmpSaveApplicantName=value.applicantName;
  this.tmpSaveClientName=value.clientName;
  this.tmpSaveClientAddress=value.clientAddress;
  this.tnpSaveRateToContractor=value.rateToContractor;
  this.tmpSaveMSATypeId=value.msaTypeId;
  this.tmpPaymentTermsId=value.templatePaymentTermsId;
  this.tmpSaveSSNNumber=value.ssnNumber;
}
clear(){
  this.initialSetup();

}
editorMaxLength(maxlength): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    var regex = /(<([^>]+)>)/ig;
    var value = control.value;
    if (value == null) {
      return null;
    }
    var result = value.replace(regex, "");
    if (result.length > maxlength) {
      return { 'maxlengthError': true };
    } else {
      return null;
    }
  }
}
OnEmailPopUp({value}: {value : VendorOnboarding}){
  if(this.isMSASelected)
    {
      value.msaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    }
    if(this.isPOSelected)
    {
      value.poAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    }
    if(this.isNCASelected)
    {
      value.ncaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    }
    if(!this.isVendorAvailable)
    {
      value.msaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
      value.poAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
     value.ncaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
    }
  //value.msaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
  //value.poAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
  value.contractStartDate=this.datePipe.transform(value.contractStartDate, 'yyyy-MM-dd');
  value.estContractEndDate=this.datePipe.transform(value.estContractEndDate, 'yyyy-MM-dd');
  //value.ncaAgreementDate=this.datePipe.transform(value.contractAgreementDate, 'yyyy-MM-dd');
  value.vendorCategoryId=this.vendorCategoryId;
  value.invoiceTermsId=this.invoiceTermsId;
  value.insuranceExhibitId=this.insuranceExhibitId;
  value.createdBy=Number(this.loggedInUserProfile.uid);
  value.createdOn=new Date();
  value.msaTypeId=this.msaTypeId;
  value.poDocTemplate=this.poTemplate;
  value.msaDocTemplate=this.msaTemplate;
  value.ncaDocTemplate=this.ncaTemplate;
  value.emailBody=(this.emailFormControl.controls['emailBody'].value == null ? null : this.emailFormControl.controls['emailBody'].value);
  value.emailIds = this.emailFormControl.controls['vendorOnboardingEmailAdd'].value.map(element => element.emailId).join(",");
  value.comments=(this.emailFormControl.controls['emailBody'].value == null ? null : this.emailFormControl.controls['emailBody'].value);
  //value.emailLinkValidityHoursId = (this.emailFormControl.controls['emailLinkValidityHoursId'].value == null ? null : this.emailFormControl.controls['emailLinkValidityHoursId'].value);
  value.emailLinkValidityHoursId = this.emailLinkValidityHoursId;
  value.emailLinkValidityHours = this.emailLinkValidityHours;
  if (this.vendorOnboardingEditId == true) {
    value.templatePaymentTermsId = this.selectedPaymentTermsEditIds;
  }
  else {
    value.templatePaymentTermsId = this.selectedPaymentTermsIds;
  }
  if(this.tmpPaymentTermsId == "" || this.tmpPaymentTermsId == undefined)
    {
      this.tmpPaymentTermsId=null;
    }
  if(value.templatePaymentTermsId == "" || value.templatePaymentTermsId == undefined)
    {
        value.templatePaymentTermsId=null;
    }
  console.log(value);
  console.log(this.tmpSaveMsaAgreementDate);
 
    if(!this.isVendorAvailable || this.isVendorAvailable &&(this.isMSASelected || this.isPOSelected || this.isNCASelected)) 
    {
      if(this.tmpSaveMsaAgreementDate!=value.msaAgreementDate || this.tmpSavePoAgreementDate!=value.poAgreementDate || this.tmpSavecontractStartDate!=value.contractStartDate || this.tmpSaveEstContractEndDate!=value.estContractEndDate || this.tmpSaveNcaAgreementDate!=value.ncaAgreementDate || this.tmpSaveVendorCategoryId!=value.vendorCategoryId || this.tmpSaveInvoiceTermsId!=value.invoiceTermsId || this.tmpSaveInsuranceExhibitId!=value.insuranceExhibitId || this.tmpSaveVendorName!=value.vendorName || this.tmpSaveTaxIdNumber!=value.taxIdNumber || this.tmpSaveAddressLine1!=value.addressLine1 || this.tmpSaveApplicantName!=value.applicantName || this.tmpSaveClientName!=value.clientName || this.tmpSaveClientAddress!=value.clientAddress || this.tnpSaveRateToContractor!=value.rateToContractor || this.tmpSaveMSATypeId!=value.msaTypeId || this.tmpPaymentTermsId!=value.templatePaymentTermsId || this.tmpSaveSSNNumber != value.ssnNumber){
  
        this.tmpSaveMsaAgreementDate=value.msaAgreementDate;
        this.tmpSavePoAgreementDate=value.poAgreementDate;
        this.tmpSavecontractStartDate=value.contractStartDate;
        this.tmpSaveEstContractEndDate=value.estContractEndDate;
        this.tmpSaveNcaAgreementDate=value.ncaAgreementDate
        this.tmpSaveVendorCategoryId=value.vendorCategoryId;
        this.tmpSaveInvoiceTermsId=value.invoiceTermsId
        this.tmpSaveInsuranceExhibitId=value.insuranceExhibitId
        this.tmpSaveVendorName=value.vendorName;
        this.tmpSaveTaxIdNumber=value.taxIdNumber;
        this.tmpSaveAddressLine1=value.addressLine1;
        this.tmpSaveApplicantName=value.applicantName;
        this.tmpSaveClientName=value.clientName;
        this.tmpSaveClientAddress=value.clientAddress;
        this.tnpSaveRateToContractor=value.rateToContractor;
        this.tmpSaveMSATypeId=value.msaTypeId;
        this.tmpPaymentTermsId=value.templatePaymentTermsId;
        this.tmpSaveSSNNumber=value.ssnNumber;
        if(!this.isVendorAvailable)
          {
            this.isNCATemplateGenerated=false;
            this.isMSATemplateGenerated=false;
            this.isPOTemplateGenerated=false;
          }
          if(this.isVendorAvailable)
          {
            this.isNCATemplateGenerated=true;
            this.isMSATemplateGenerated=true;
            this.isPOTemplateGenerated=true;
          }
          if(this.isVendorAvailable && this.isMSASelected)
          {
            this.isMSATemplateGenerated=false;
          }
          if(this.isVendorAvailable && this.isNCASelected)
          {
            this.isNCATemplateGenerated=false;
          }
          if(this.isVendorAvailable && this.isPOSelected)
          {
            this.isPOTemplateGenerated=false;
          }    
        // if(this.msaTypeId==MSAType.Standard1099 || this.msaTypeId==MSAType.Special1099){
        //   this.isNCATemplateGenerated=false;
        // }
        // else{
        //   this.isNCATemplateGenerated=true;
        // }
        this.validationErrorMessage="One or more field(s) has been edited. Please generate all the templates (MSA, PO and NCA) again to submit the vendor onboarding record"
        this.isMSAEditTemplateWarning=true;
        return;
        }
    }
  
    this.isEmailDialog=true;
  }
addAdjustmentAmount(i: number){
  let vendorOnboardingEmailAdd = this.emailFormControl.get("vendorOnboardingEmailAdd") as FormArray;
  let newVendorOnboardingEmailAdd= this.fb.group({
    emailId: new FormControl('',[Validators.required,Validators.pattern(VMSConstants.emailValidator)]),
  });
  vendorOnboardingEmailAdd.push(newVendorOnboardingEmailAdd);
}
removeAdjustmentFields(i: number) {
  let arr = this.emailFormControl.get("vendorOnboardingEmailAdd") as FormArray;
  arr.removeAt(i);
}

GetVendorOnboardProcess(tempEmailLinkRefId){
  this.vendorOnboardingEditId= true;
  this.vendorOnboardingService.GetVendorOnboardProcess(tempEmailLinkRefId).subscribe((value: any) => {
this.tempVendorId=value.tempVendorId;
console.log(value);
if(value.isVendorAvailable)
{
  this.breadcrumbTitle='Edit - Send Document Link'; 
  this.pageHeader='Edit - Send Document Link - '+value.vendorName
}
else{
  this.breadcrumbTitle='Edit - Vendor Onboarding'; 
  this.pageHeader='Edit - Vendor Onboarding - '+value.vendorName
}

this.tmpEditVendorName=value.vendorName;
this.tmpEditTaxId=value.taxIdNumber;
this.tmpEditVendorAddress=value.addressLine1;

this.tmpEditMSAAgreementDate=this.datePipe.transform(value.msaAgreementDate, 'yyyy-MM-dd');

this.tmpEditMSATypeId=value.msaTypeId;
this.tmpEditClientName=value.clientName;
this.tmpEditClientAddress=value.clientAddress;
this.tmpEditPoAgreementDate=this.datePipe.transform(value.poAgreementDate, 'yyyy-MM-dd');
this.tmpEditcontractStartDate=this.datePipe.transform(value.contractStartDate, 'yyyy-MM-dd');
this.tmpEditEstContractEndDate=this.datePipe.transform(value.estContractEndDate, 'yyyy-MM-dd');
this.tmpEditRateToContractor=value.rateToContractor;
this.tmpEditSSNNumber=value.ssnNumber;
this.isVendorAvailable= false;
if(value.vendorId != null)
  {
    this.vendorId = value.vendorId;
    this.isVendorAvailable = true;
  }
this.isMSASelected = value.isMSASelected;
this.isPOSelected = value.isPOSelected;
this.isNCASelected = value.isNCASelected;
this.isVoidChequeSelected =value.isVoidChequeSelected;
this.isW9Selected = value.isW9Selected;
this.isI9Selected = value.isI9Selected;
this.isDDSelected = value.isDDSelected;
this.isCOISelected = value.isCOISelected;
this.isEVerificationSelected = value.iseVerificationSelected;

if(value.msaDocumentTemplate !=null){
  this.tmpMSATemplate=value.msaDocumentTemplate.generatedTemplate;
  this.msaTemplate=value.msaDocumentTemplate.generatedTemplate;
}
else{
  this.tmpMSATemplate=null;
}
if(value.ncaDocumentTemplate !=null){
  this.tmpNCATemplate=value.ncaDocumentTemplate.generatedTemplate;
  this.ncaTemplate=value.ncaDocumentTemplate.generatedTemplate;
}
else{
  this.tmpNCATemplate=null;
}
if(value.poDocumentTemplate !=null){
  this.tmpPOTemplate=value.poDocumentTemplate.generatedTemplate;
  this.poTemplate=value.poDocumentTemplate.generatedTemplate;
}
else{
  this.tmpPOTemplate=null;
}
this.tmpEditApplicantName=value.applicantName;
this.tmpNCAEditAgreementDate=this.datePipe.transform(value.ncaAgreementDate, 'yyyy-MM-dd');
this.tmpEditTemplatePaymentTermsId = value.templatePaymentTermsId == null ? '':value.templatePaymentTermsId;

  this.vendorNameAvail=false;
  this.isSaveAvailable=true;
if(value.invoiceTermsId != null)
{
  this.companyService.getInvoiceTerms(value.invoiceTermsId).subscribe((data: any) => {
    this.selectedInvoiceTermsId = data;
    this.invoiceTermsId = value.invoiceTermsId;
    this.invoiceTermEnable = true;
  });
}
if(value.msaTypeId != null && value.msaTypeId != undefined){
  var arr=this.arrMSAType.filter(item => item.lookupOrder == value.msaTypeId);
  this.selectedMSATypeId =  arr[0];
  this.isMSAType=true;
  this.msaTypeId = value.msaTypeId;
  const taxIdNumber = this.VendorOnboardingForm.get('taxIdNumber');
    const ssnNumber = this.VendorOnboardingForm.get('ssnNumber');
  if(this.msaTypeId==MSAType.Standard1099 || this.msaTypeId==MSAType.Special1099){
    ssnNumber.setValidators([Validators.required,Validators.minLength(9)]);
    taxIdNumber.clearValidators();
    this.isMSAType1099=true;
  }
  else{
    taxIdNumber.setValidators([Validators.required,Validators.minLength(9)]);
    ssnNumber.clearValidators();
    this.isMSAType1099=false;
  }
  taxIdNumber.updateValueAndValidity();
  ssnNumber.updateValueAndValidity();
  // const ncaAgreementDate = this.VendorOnboardingForm.get('ncaAgreementDate');

  // if(this.msaTypeId==MSAType.Standard1099 || this.msaTypeId==MSAType.Special1099){
  //   this.isNCA=true;
  //   this.isNCATemplateGenerated=false;
  //   ncaAgreementDate.setValidators([Validators.required]);
  //   this.showPaymentTerms =true;
  // }
  // else{
  //   this.isNCA=false;
  //   this.isNCATemplateGenerated=true;
  //   ncaAgreementDate.clearValidators();
  // }
  // ncaAgreementDate.updateValueAndValidity();
  if(this.msaTypeId==MSAType.Special1099 || this.msaTypeId==MSAType.SpecialC2C){
this.isSpecial=true;

this.isPaymentTermRequired = false;
if(this.msaTypeId==MSAType.Special1099){
  this.isSpecial1099=true;
  this.isSpecialC2C=false;
  }
  else if(this.msaTypeId==MSAType.SpecialC2C)
  {
    this.isSpecialC2C=true;
    this.isSpecial1099=false;
  }

  }
  else{
    this.isSpecial=false;
this.isPaymentTermRequired=false;
this.paymentTermsIds = [];
this.selectedPaymentTerms = undefined;
this.selectedPaymentTermsIds = '';
this.selectedPaymentTermsEditIds = '';
this.isSpecial1099=false;
this.isSpecialC2C=false;
  }
}
if(value.insuranceExhibitId != null && value.insuranceExhibitId != undefined){
  var arr=this.arrInsuranceExhibit.filter(item => item.lookupOrder == value.insuranceExhibitId);
  this.selectedExhibitTypeId =  arr[0];
 this.insuranceExhibitId=value.insuranceExhibitId;
 this.isInsuranceExhibit=true;
}
this.companyService.getClientListForRegistration(value.vendorCategoryId).subscribe((data: any) => {
  if (data != null || data != undefined) {
    this.selectedClientRegistrationId = data;
    this.selectedClientValidOnRegistration = false;

    this.vendorCategoryId = value.vendorCategoryId;
  }
});

if(value.templatePaymentTermsId != null && value.templatePaymentTermsId != ''){
const arrayPaymentTermsId = value.templatePaymentTermsId.split(',');
for(var i = 0; i < arrayPaymentTermsId.length; i++)
{
   for(var j = 0; j < this.paymentTerms.length; j++) {
    if (arrayPaymentTermsId[i] == this.paymentTerms[j].lookupOrder) {
      this.paymentTermsIds.push(this.paymentTerms[j]);
      this.selectedPaymentTerms = this.selectedPaymentTerms + this.paymentTerms[j].description;
      if (this.selectedPaymentTermsEditIds == undefined) {
        this.selectedPaymentTermsEditIds = this.paymentTerms[j].lookupOrder;
      }
      else {
        this.selectedPaymentTermsEditIds = this.selectedPaymentTermsEditIds + ',' + this.paymentTerms[j].lookupOrder;
      }

    }
   }
}
}
else {
  this.selectedPaymentTermsIds = '';
  this.selectedPaymentTermsEditIds = '';
}

if(!this.isVendorAvailable)
{
  this.VendorOnboardingForm = this.fb.group({
    vendorName: new FormControl(value.vendorName, [Validators.required]),
    taxIdNumber: new FormControl(value.taxIdNumber),
    msaAgreementDate: new FormControl(value.msaAgreementDate != null ? new Date(value.msaAgreementDate) : null),
    addressLine1: new FormControl(value.addressLine1, [Validators.required]),
    applicantName: new FormControl(value.applicantName, [Validators.required]),
    clientName:new FormControl(value.clientName, [Validators.required]),
    clientAddress:new FormControl(value.clientAddress, [Validators.required]),
    poAgreementDate:  new FormControl(value.poAgreementDate != null ? new Date(value.poAgreementDate) : null),
    contractStartDate:  new FormControl(value.contractStartDate != null ? new Date(value.contractStartDate) : null, [Validators.required]),
    estContractEndDate: new FormControl(value.estContractEndDate != null ? new Date(value.estContractEndDate) : null),
    rateToContractor: new FormControl(value.rateToContractor,[Validators.required]),
    ncaAgreementDate: new FormControl(value.ncaAgreementDate != null ? new Date(value.ncaAgreementDate) : null),
    ssnNumber:new FormControl(value.ssnNumber),
    contractAgreementDate:  new FormControl(value.poAgreementDate != null ? new Date(value.poAgreementDate) : null, [Validators.required]),
  
  });
  this.isMSATemplateGenerated=true;
  this.isNCATemplateGenerated=true;
  this.isPOTemplateGenerated=true;
}

if(this.isVendorAvailable)
{
  this.VendorOnboardingForm = this.fb.group({
    vendorName: new FormControl(value.vendorName, [Validators.required]),
    taxIdNumber: new FormControl(value.taxIdNumber),
    msaAgreementDate: new FormControl(value.msaAgreementDate != null ? new Date(value.msaAgreementDate) : null),
    addressLine1: new FormControl(value.addressLine1),
    applicantName: new FormControl(value.applicantName),
    clientName:new FormControl(value.clientName),
    clientAddress:new FormControl(value.clientAddress),
    poAgreementDate:  new FormControl(value.poAgreementDate != null ? new Date(value.poAgreementDate) : null),
    contractStartDate:  new FormControl(value.contractStartDate != null ? new Date(value.contractStartDate) : null),
    estContractEndDate: new FormControl(value.estContractEndDate != null ? new Date(value.estContractEndDate) : null),
    rateToContractor: new FormControl(value.rateToContractor,[Validators.required]),
    ncaAgreementDate: new FormControl(value.ncaAgreementDate != null ? new Date(value.ncaAgreementDate) : null),
    ssnNumber:new FormControl(value.ssnNumber),
    contractAgreementDate:  new FormControl(value.poAgreementDate != null ? new Date(value.poAgreementDate) : null),
  
  });
  const vendorAddress = this.VendorOnboardingForm.get('addressLine1');
  const contractAgreementDate  = this.VendorOnboardingForm.get('contractAgreementDate');
  const applicantName = this.VendorOnboardingForm.get('applicantName');
  const clientName = this.VendorOnboardingForm.get('clientName');
  const clientAddress = this.VendorOnboardingForm.get('clientAddress');
  const contractStartDate  = this.VendorOnboardingForm.get('contractStartDate');
  const estContractEndDate  = this.VendorOnboardingForm.get('estContractEndDate');
  const rateToContractor  = this.VendorOnboardingForm.get('rateToContractor');
  vendorAddress.clearValidators();
  contractAgreementDate.clearValidators();
  applicantName.clearValidators();
  clientName.clearValidators();
  clientAddress.clearValidators();
  contractStartDate.clearValidators();
  estContractEndDate.clearValidators();
  rateToContractor.clearValidators();
  this.vendorNameAvail=false;
  this.isMSATemplateGenerated=true;
  this.isPOTemplateGenerated=true;
  this.isNCATemplateGenerated=true;
  if(this.isMSASelected)
  {
   //this.isSaveAvailable = true;
   //this.isMSATemplateGenerated=false;
     //vendorName.setValidators([Validators.required]);
     contractAgreementDate.setValue(new Date(value.msaAgreementDate));
     vendorAddress.setValidators([Validators.required]);
     contractAgreementDate.setValidators([Validators.required]);
     vendorAddress.updateValueAndValidity();
     contractAgreementDate.updateValueAndValidity();
  }
  if(this.isPOSelected)
  {
    
    //this.isSaveAvailable = true;
    //this.isPOTemplateGenerated=false;
    contractAgreementDate.setValue(new Date(value.poAgreementDate));
    vendorAddress.setValidators([Validators.required]);
    contractAgreementDate.setValidators([Validators.required]);
    applicantName.setValidators([Validators.required]);
    clientName.setValidators([Validators.required]);
    clientAddress.setValidators([Validators.required]);
    contractStartDate.setValidators([Validators.required]);
   // estContractEndDate.setValidators([Validators.required]);
    rateToContractor.setValidators([Validators.required]);
    
    vendorAddress.updateValueAndValidity();
    contractAgreementDate.updateValueAndValidity();
    applicantName.updateValueAndValidity();
    clientName.updateValueAndValidity();
    clientAddress.updateValueAndValidity();
    contractStartDate.updateValueAndValidity();
    //estContractEndDate.updateValueAndValidity();
    rateToContractor.updateValueAndValidity();
  }
  if(this.isNCASelected)
  {
    //this.isSaveAvailable = true;
    //this.isNCATemplateGenerated=false;
    contractAgreementDate.setValue(new Date(value.ncaAgreementDate));
    vendorAddress.setValidators([Validators.required]);
    contractAgreementDate.setValidators([Validators.required]);
    applicantName.setValidators([Validators.required]);
    vendorAddress.updateValueAndValidity();
    contractAgreementDate.updateValueAndValidity();
    applicantName.updateValueAndValidity();
  }
}
this.spinner.hide();
  });
  this.spinner.hide();
}

getPaymentTerms() {
  this.categoryName = 'Payment Terms';
  this.sharedService.getLookupMasterByCategoryId(LookupCategory.PaymentTerms).subscribe((data: any) => {
    //this.paymentTerms = data;
    this.paymentTerms = data.filter(item => item.description !== 'Others' && item.description !== 'Pay once the payment is received' );
  });
}

getPaymentTermsOnChange(event) {
  if (this.paymentTermsIds.length == 0) {
    this.selectedPaymentTerms = undefined;
    this.isPaymentTermRequired = true;
    this.selectedPaymentTermsIds = '';
    this.selectedPaymentTermsEditIds = '';
  }
  else {
    this.isPaymentTermRequired = false;
  }
  if (this.vendorOnboardingEditId == true) {
    if (this.selectedPaymentTermsEditIds != '' || this.selectedPaymentTermsEditIds != undefined) {
      this.selectedPaymentTermsEditIds = '';
      for (var m = 0; m < event.value.length; m++) {
        if (event.value.length == 1) {
          this.selectedPaymentTermsEditIds =   event.value[m].lookupOrder ;
        }
          else{
            this.selectedPaymentTermsEditIds = this.selectedPaymentTermsEditIds + ',' + event.value[m].lookupOrder ;
          }
       
      }

    }
    else {
      if (event.value.length == 1) {
        this.selectedPaymentTermsEditIds = event.value[0].lookupOrder;
      }
      else {

        this.selectedPaymentTermsEditIds = "";
        for (var k = 0; k < event.value.length; k++) {
          if (k==0) {
            this.selectedPaymentTermsEditIds = event.value[0].lookupOrder;
          }
          else{
            this.selectedPaymentTermsEditIds = this.selectedPaymentTermsEditIds + ',' + event.value[k].lookupOrder ;
          }
          
        }
      }

    }
  }
  else {
    if (event.value.length == 1) {
      this.selectedPaymentTermsIds = event.value[0].lookupOrder;
    }
    else {
      this.selectedPaymentTermsIds = "";
      for (var k = 0; k < event.value.length; k++) {
        if (k==0) {
          this.selectedPaymentTermsIds =  event.value[k].lookupOrder;
        }
        else{
          this.selectedPaymentTermsIds = this.selectedPaymentTermsIds + ',' + event.value[k].lookupOrder;
        }
      }
    }
  }
  console.log(this.selectedPaymentTermsIds);
}

closePreviewSpecialMSATemplate()
{
  this.specialMSATemplateForUpdate = this.msaTemplate;
  this.previewSpecialMSATemplate = false;
}

updateSpecialMSATemplate()
{
    this.msaTemplate = this.specialMSATemplateForUpdate;
    this.tmpEditVendorName=this.VendorOnboardingForm.controls['vendorName'].value;
    this.tmpEditTaxId=this.VendorOnboardingForm.controls['taxIdNumber'].value;
    this.tmpEditVendorAddress=this.VendorOnboardingForm.controls['addressLine1'].value;
    this.tmpEditMSAAgreementDate=this.datePipe.transform(this.VendorOnboardingForm.controls['contractAgreementDate'].value, 'yyyy-MM-dd');
    //this.tmpEditTemplatePaymentTermsId=value.templatePaymentTermsId;
    if (this.vendorOnboardingEditId == true) {
      this.tmpEditTemplatePaymentTermsId = this.selectedPaymentTermsEditIds;
    }
    else {
      this.tmpEditTemplatePaymentTermsId = this.selectedPaymentTermsIds;
    }
    this.tmpEditSSNNumber=this.VendorOnboardingForm.controls['ssnNumber'].value;
  this.previewSpecialMSATemplate = false;
  this.tmpMSATemplate= this.specialMSATemplateForUpdate;
  this.messageService.add({key:'save', severity:'success', detail:'MSA generated successfully'});
  //After Successfull Update
  this.isMSATemplateGenerated=true;

}
validationErrorPopUpClose(){
  this.isMSAEditTemplateWarning=false;
}
onCancelEmailPopUp(){
  this.isEmailDialog=false;
  this.loadingSaveButton = false;
  this.emailFormControl.reset();
//   this.emailFormControl=this.fb.group({ 
//     emailBody:new FormControl("", [this.editorMaxLength(10000)]),
//     applicantEmailId:new FormControl(''),
//     emailLinkValidityHoursId:new FormControl(null,[Validators.required]),
//     emailLinkValidityHours:new FormControl(""),
//     vendorOnboardingEmailAdd:new FormArray([this.fb.group({
//     emailId: new FormControl('', [Validators.required,Validators.pattern(VMSConstants.emailValidator)]),
//   })])
// });
// const applicantEmailId = this.emailFormControl.get('applicantEmailId');
//     if (this.msaTypeId == MSAType.Standard1099 || this.msaTypeId == MSAType.Special1099) {
//       applicantEmailId?.clearValidators();
//       applicantEmailId?.setValue('');
//       this.isMSAType1099 = true;
//     }
//     else {
//       applicantEmailId?.setValidators([Validators.required, Validators.pattern(VMSConstants.emailValidator)])
//       this.isMSAType1099 = false;
//     }
//     applicantEmailId?.updateValueAndValidity();
}
checkViewPermission()
{
    var permission =this.jwtService.getLoggedInUserProfile();
    if(permission ==0)
    {
     this.router.navigateByUrl('/login');
    }
}

closePreviewSpecialPOTemplate()
{
  this.specialPOTemplateForUpdate = this.poTemplate;
  this.previewSpecialPOTemplate = false;
}

updateSpecialPOTemplate()
{
  this.poTemplate = this.specialPOTemplateForUpdate;
  this.tmpEditVendorName=this.VendorOnboardingForm.controls['vendorName'].value;
  this.tmpEditTaxId=this.VendorOnboardingForm.controls['taxIdNumber'].value;
  this.tmpEditVendorAddress=this.VendorOnboardingForm.controls['addressLine1'].value;
  this.tmpEditPoAgreementDate=this.datePipe.transform(this.VendorOnboardingForm.controls['contractAgreementDate'].value, 'yyyy-MM-dd');
  //this.tmpEditTemplatePaymentTermsId=this.paymentTermsId;
  this.tmpEditMSATypeId=this.msaTypeId;
  this.tmpEditClientName=this.VendorOnboardingForm.controls['clientName'].value;
  this.tmpEditClientAddress=this.VendorOnboardingForm.controls['clientAddress'].value;
  //this.tmpEditPoAgreementDate=this.datePipe.transform(this.VendorOnboardingForm.controls['poAgreementDate'].value, 'yyyy-MM-dd');
  this.tmpEditcontractStartDate=this.datePipe.transform(this.VendorOnboardingForm.controls['contractStartDate'].value, 'yyyy-MM-dd');
  this.tmpEditEstContractEndDate=this.datePipe.transform(this.VendorOnboardingForm.controls['estContractEndDate'].value, 'yyyy-MM-dd');
  this.tmpEditRateToContractor=this.VendorOnboardingForm.controls['rateToContractor'].value;
  this.tmpEditSSNNumber=this.VendorOnboardingForm.controls['ssnNumber'].value;
  this.previewSpecialPOTemplate = false;
  this.tmpPOTemplate= this.specialPOTemplateForUpdate;
  this.tmpEditApplicantName=this.VendorOnboardingForm.controls['applicantName'].value;
  this.messageService.add({key:'save', severity:'success', detail:'PO generated successfully'});
  //After Successfull Update
  this.isPOTemplateGenerated=true;

}

closePreviewSpecialNCATemplate()
{
  this.specialNCATemplateForUpdate = this.ncaTemplate;
  this.previewSpecialNCATemplate = false;
}

updateSpecialNCATemplate()
{
  this.ncaTemplate = this.specialNCATemplateForUpdate;
  this.tmpEditApplicantName=this.VendorOnboardingForm.controls['applicantName'].value;
  this.tmpNCAEditAgreementDate=this.datePipe.transform(this.VendorOnboardingForm.controls['contractAgreementDate'].value, 'yyyy-MM-dd');
  this.previewSpecialNCATemplate = false;
  this.tmpNCATemplate= this.specialNCATemplateForUpdate;
  this.messageService.add({key:'save', severity:'success', detail:'NCA generated successfully'});
  //After Successfull Update
  this.isNCATemplateGenerated=true;

}
validateInput(event: any) {
  const inputChar = event.data;
  if (inputChar && inputChar !== 'x' && isNaN(Number(inputChar))) {
    event.target.value = event.target.value.replace(inputChar, '');
  }
}

  getlinkValidityTypes() {
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.EmailLinkValidityHours).subscribe((data: any) => {
      this.linkValidityTypes = data;
      this.linkValidityTypes.sort((a: any, b: any) => (a.lookupOrder < b.lookupOrder) ? -1 : 1);
    });
  }

  getEmailLinkValidityOnChange(event) {
    this.emailLinkValidityHours = event.value.description;
    this.emailLinkValidityHoursId = event.value.lookupOrder;
  }
}
